import { render, staticRenderFns } from "./Bear.vue?vue&type=template&id=7c63031d&scoped=true"
import script from "./Bear.vue?vue&type=script&lang=js"
export * from "./Bear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63031d",
  null
  
)

export default component.exports